import Moment from 'moment';
import isMobile from '../components/IsMobile';
import { DateRange } from '../redux/dateRangeSlice';
import { getRangeHours } from '../constants/Utils';

export type ChartDataPoint = {
  index: number,
  value: number,
  date: string,
}

export const formatTickValues = (t: number) => {
  if (t >= 1000000) return `${(t / 1000000)}M`;
  if (t >= 1000) return `${(t / 1000)}K`;
  return t;
};

export const tickValSamples = (unfilteredArray: any[], dateTickCount: number) => dateTickCount
  && unfilteredArray
    .filter((_, index, array) => index === 0 || [...Array(dateTickCount).keys()]
      .map((item) => ((index > array.length / 2)
        ? Math.ceil(((array.length - 1) * item) / (dateTickCount - 1))
        : Math.floor(((array.length - 1) * item) / (dateTickCount - 1))))
      .includes(index));

const differenceHours = (axisData: { date: string }[]) => Math.abs(new Date(axisData[
  axisData.length - 1]?.date).valueOf() - new Date(axisData[0]?.date).valueOf()) / 3600000;

export const tooltipDateLabel = (
  axisData: { date: string }[],
  index: number,
  short?: boolean,
  showTime: boolean = true,
) => {
  const weekday: 'short' | 'long' = short ? 'short' : 'long';
  const month: 'short' | 'long' = weekday;
  const date = new Date(axisData[index]?.date);
  if (!axisData[index]?.date) return '-';
  const diff: number = differenceHours(axisData);
  if (!isMobile) {
    if (diff <= 24) return Moment(date).format('MMM DD[, ]h:mm a');
    if (diff <= 192) return `${date.toLocaleString('en-us', { weekday })}: ${Moment(date).format(`MMM DD${showTime ? '[, ]h a' : ''}`)}`;
    return `${date.toLocaleString('en-us', { weekday })}: ${date.toLocaleString('default', { month })} ${date.getDate()}`;
  }
  if (diff <= 24) return Moment(date).format('h:mm a');
  if (diff <= 192) return Moment(date).format('MMM DD[, ] h a');
  return `${date.toLocaleString('en-us', { weekday: 'short' })}: ${Moment(date).format('MMM DD')}`;
};

export const axisDateLabel = (axisData: { date: string }[], index: number, range?: DateRange) => {
  if (!axisData[index]?.date) return '';
  const diff: number = range ? getRangeHours(range) : differenceHours(axisData);
  if (diff < 8) return Moment(axisData[index].date).format('h:mm a');
  if (diff < 24) return Moment(axisData[index].date).format('h a');
  return Moment(axisData[index].date).format('MMM DD');
};

export const checkIfDatesIdentical = (start: Date | string, end: Date | string) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  return startDate.getDate() === endDate.getDate() && startDate.getMonth() === endDate.getMonth()
    && startDate.getFullYear() === endDate.getFullYear();
};

export const hideRepeatedSuffix = (index: number, indices: number[], values: string[]) => {
  if (index === 0) return values[indices[index]];
  const currentMonth: string = values[indices[index]]?.split('\n')[1];
  const prevMonth: string = values[indices[index - 1]]?.split('\n')[1];
  if (currentMonth === prevMonth) return values[indices[index]]?.split('\n')[0];
  return values[indices[index]];
};
